<template>
    <div class="crew-position-card">
        <div v-for="(pos, idx) in positions" :key="idx" class="crew-position-row">
            <span style="margin-left: 16px;">{{ formatDate(pos.start_at) }}~</span>
            <span>{{ pos.position_name }}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        positions: { type: Array, default: () => [] }
    },
    methods: {
        formatDate(dateStr) {
            if (!dateStr) return "";
            const d = new Date(dateStr);
            return `${d.getFullYear()}/${(d.getMonth() + 1).toString().padStart(2, "0")}/${d.getDate().toString().padStart(2, "0")}`;
        }
    }
};
</script>
<style scoped>
.crew-position-card {
    display: flex;
    flex-direction: column;
    padding: 16px;
}

.crew-position-row {
    display: flex;
    height: 32px;
    gap: 16px;
    font-size: 12px;
    font-weight: bold;
}
</style>